<template>
  <AttrGroup title="表盘整体配色">
    <div class="px-2.5">
      <div v-if="colors.length" class="">
        <div class="grid grid-cols-3 gap-y-3 bg-black-card p-2.5 rounded-xl">
          <div
            v-for="color in colors"
            :key="color"
            class="flex items-center gap-2"
          >
            <div
              class="w-5 h-5 rounded-full"
              :style="{
                backgroundColor: color
              }"
            />
            <div class="select-text">
              {{ color }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="opacity-70 text-center">表盘未设置多配色；</div>
    </div>
  </AttrGroup>
</template>

<script setup lang="ts">
import { useEmitterListener } from '@/hooks';
import { useRuntimeStore } from '@/store/use-runtime-store';
import { EventType } from '@/utils/emitter.utils';
import { onMounted, ref } from 'vue';

// 色值
const colors = ref<string[]>([]);
const runtimeStore = useRuntimeStore();

const resetColors = () => {
  const attrsMap = runtimeStore.watchfaceAst.attrsMap;
  colors.value =
    (attrsMap?.['colorGroupTable'] ?? attrsMap?.['recolorTable'])?.split(',') ??
    [];
};
useEmitterListener(EventType['maml:rendered'], () => {
  resetColors();
});

onMounted(() => {
  resetColors();
});
</script>

<style lang="less" scoped></style>
